<div class="container celerity-page">
  <div class="row">
    <div class="col celerity-page-header">
      <h1>{{title}}</h1>
      <ng-content select="[page-actions]"></ng-content>
    </div>
  </div>
  <ng-content select="[page-content]"></ng-content>
</div>
